import { isValidURL } from './validations';
export function toValidURL(input) {
  const trimmedInput = input.trim();
  if (!trimmedInput) {
    return null;
  }
  const hasProtocol = /^https?:\/\//i.test(trimmedInput);
  const urlToTest = hasProtocol ? trimmedInput : `https://${trimmedInput}`;
  if (!isValidURL(urlToTest)) {
    return null;
  }
  try {
    return new URL(urlToTest);
  } catch {
    return null;
  }
}
export function toCurrencySymbol(locale, currency) {
  try {
    const formatted = 0 .toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      style: 'currency',
      currency
    });
    return formatted.replace(/[\d.,\s]/g, '').trim();
  } catch (error) {
    return undefined;
  }
}
//# sourceMappingURL=formats.js.map